<template style="height: 100%;">
  <div class="Testreport" id="prints">
    <div class="userreport-app" v-loading="loading">
      <div class="se" v-html="PaperReReportName">{{ PaperReReportName }}</div>
      <div class="basic-info" v-html="PaperReRepPerlDetails">
        {{ PaperReRepPerlDetails }}
      </div>
      <div @click="eventTemp" v-html="PaperReReportContent">{{ PaperReReportContent }}</div>
      <div v-html="PaperReRepAffContent">{{ PaperReRepAffContent }}</div>
      <div v-html="PaperReRepAttaContent">{{ PaperReRepAttaContent }}</div>
    </div>
    <el-dialog :title="ti[index].title" :visible.sync="dialogVisible" width="90%" style="text-align: center;">
      <span class="span1">{{ ti[index].nav }}</span>
      <span class="span1">{{ ti[index].en }}</span>
    </el-dialog>
  </div>
</template>
<script>
import { json } from 'body-parser'

export default {
  data() {
    return {
      index: 0,
      dialogVisible: false,
      pageTitle: '移动端报告',
      textarea: '',
      PaperReRepAffContent: '',
      PaperReRepAttaContent: '',
      PaperReRepPerlDetails: '',
      PaperReReportContent: '',
      PaperReReportName: '',
      loading: true,
      PaperResultID: '',
      UserID: '',
      TerminalType: 'APP',
      from: {
        Name: '',
        Student: '',
        ScaleName: '',
        TestTime: [],
        PublishID: '',
        PublishID: '',
        ObjectS: '',
        DeptID: '',
        StudyTime: '',
        Warning: [],
      },
      ti: [{
        title: '原始分介绍',
        nav: '原始分是根据问卷答题直接计算得来的分数。由于原始分的不等性和不确定性，原始分通常是无意义的，需要转换为标准分后，方可帮助测试者判断理解自身的心理水平。',
        en: 'The raw score is directly calculated based on your answers in the questionnaire. However, the raw score is usually meaningless. It needs to be converted to a standard score to help the subject to understand his/her psychological status.'
      }, {
        title: '标准分介绍',
        nav: '标准分是由原始分转化而得来，是测试结果中测试者真正应当关注的分数。测试者需依据标准分来在结果分值范围内判断自身的心理水平。如分值范围为0-10，标准分为6分，说明测试者是在10分制下得了6分。',
        en: 'The standard score, to which is the score a subject should pay attention, is converted from the raw score. A subject needs to understand his/her psychological status based on the standard score. For example, if the score range is from 0 to 10, and the standard score is 6, then it indicates that the subject scored 6 points on a 10-point system.'
      }, {
        title: '均分介绍',
        nav: '均分是原始分的平均值，测试者可依据均分大概了解量表反映的心理水平的集中趋势；如分值范围为1-10，均分为2，说明测试者更倾向于低分值所代表的心理水平。',
        en: 'The mean score is the mean value of the original score, according to which the test subject can approximate the central tendency level of their psychological level based on the scale taken. If the mean score of the scale is set to a range from 1 to 10, and the mean score of the test subject is 2, it indicates that the subject is inclined to have the psychological level represented by the lower score.'
      }
      ],
    }
  },
  methods: {},
  metaInfo: {
    title: '移动端报告',
    meta: [{ name: 'viewport', content: 'width=device-width,initial-scale=1.0,minimum-scale=1.0,maximum-scale=1.0,user-scalable=no', }],
  },
  methods: {
    eventTemp(e) {//根据点击元素类名触发事件
      if (e.target.className === 'scoreSrc el-icon-question Src') {
        this.dialogVisible = true;
        this.index = 0;
      } else if (e.target.className === 'scoreSrc el-icon-question Stand') {
        this.dialogVisible = true;
        this.index = 1;
      } else if (e.target.className === 'scoreSrc el-icon-question Avg') {
        this.dialogVisible = true;
        this.index = 2;
      }
    },
  },
  mounted() {
    this.PaperResultID = this.$route.query.PaperResultID;
    this.UserID = this.$route.query.UserID || '';
    // this.UserID = encodeURIComponent(this.$route.query.UserID);
    // console.log(this.$route.query.UserID)
    // console.log(this.UserID)
     
    if (this.UserID && this.UserID.includes(" ")) {
      this.UserID = this.UserID.replace(/ /g, "+");
    }


    this.TerminalType = this.$route.query.TerminalType;
    this.$Http_Post('Paper/GetPaperReportDataForApp', { PaperResultID: this.PaperResultID, UserID: this.UserID, TerminalType: this.TerminalType })
      .then((res) => {
        if (res.Code == 200 || res.Code == 0) {
          this.PaperReRepAffContent = res.Data.PaperReRepAffContent;
          this.PaperReRepAttaContent = res.Data.PaperReRepAttaContent;
          this.PaperReRepPerlDetails = res.Data.PaperReRepPerlDetails;
          this.PaperReReportContent = res.Data.PaperReReportContent;
          this.PaperReReportName = res.Data.PaperReReportName;
          this.textarea = res.Data.Diagnosis;
          this.loading = false;
        }
      })
      .catch((err) => {
        this.$message({ type: 'error', message: err.message })
      })
  },
}
</script>
<style>
.Testreport {
  height: 100%;
  margin: 0;
  padding: 0;
}

.userreport-app {
  min-height: 100%;
  padding: 10px 5%;
  background-color: #dae9f6;
}

.userreport-app .se {
  color: #0973d3;
  height: 35px;
  line-height: 35px;
  text-align: center;
  font-weight: bold;
  font-size: 18px;
}

.basic-info {
  margin: 5px 0px;
}

h3 {
  text-align: left;
  font-size: 15px;
  margin-bottom: 5px;
  color: #0973d3;
}

p {
  line-height: 25px;
}

.basic-info p b {
  margin-right: 5px;
}

.basic-info p span {
  margin-right: 5px;
}

table {
  width: 100%;
  text-align: center;
  border-collapse: collapse;
}

table,
table tr th,
table tr td {
  line-height: 25px;
  border: 1px solid #0094ff;
}

.scoreSrc {
  width: 16px;
  height: 16px;
  display: inline-block;
  border-radius: 50%;
  margin-right: 4px;
}

#prints .el-dialog__body .span1 {
  text-indent: 20px;
  text-align: left;
  text-indent: 20px;
  display: inline-block;
  line-height: 26px;
}
</style>
